export default __webpack_public_path__ + "static/media/placeholder-league-cover.ee176493.svg";